import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import TablaFacturas from "./tablaFactura.js";
import TablaRetenOrdenPago from "./tablaRetencionOrdenPago";
import TablaRetenISLR from "./tablaRetenISLR";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
} from "../../util/varios";
import ValidarUsuario from "../comun/modalValidarUsuario";
import { CambiodeDatos } from "../comun/modalCambiodDatos";
import { numeroaLetra } from "../../util/NumeroaLetra";
import { ModalModificarFact } from "./modalModificarFactura.js";
import CatalogoFondoAvanceAprob from "../../catalogos/catalogoFondoAvanceAprob";
import CatalogoConceptoAumentoFondoAvance from "../../catalogos/catalogoConceptoAumentoFondoAvance.js";
import CatalogoAprobacionesFondoTerc1 from "../../catalogos/catalogoAprobacionesFondoTerc1.js";
import CatalogoProveedor from "../../catalogos/catalogoProveedor";
import CatalogoPagadoReposi from "../../catalogos/catalogoPagadoReposi.js";
import CatalogoSPagoObra1 from "../../catalogos/catalogoSPagoObra1.js";
import CatalogoOrdenPagoxPagar from "../../catalogos/catalogoOrdenPagoxPagar.js";

import {
  SearchInput,
  Select,
  Input,
  Textarea,
} from "../../ui/inputs/Input.jsx";
import {
  DangerButton,
  InfoButton,
  SuccessButton,
  WarningButton,
} from "../../ui/buttons/Button.jsx";

export const ActualizarOrdenPagoF = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const anioefis = JSON.parse(localStorage.getItem("efiscalanio"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const liquidador = JSON.parse(localStorage.getItem("liquidador"));
  const idProv = JSON.parse(localStorage.getItem("idproveedor"));
  const ip = JSON.parse(localStorage.getItem("ip"));
  const mac = JSON.parse(localStorage.getItem("mac"));
  const numCaja = JSON.parse(localStorage.getItem("numcaja"));
  const [anio, setAnio] = useState();
  const [idEfis, setIdEfis] = useState();

  const [tabs, setTabs] = useState({
    tab1: "tab-pane fade show active",
    tab3: "tab-pane",
    tab4: "tab-pane",
  });
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [mostrar6, setMostrar6] = useState(false);
  const [mostrar7, setMostrar7] = useState(false);
  const [mostrar8, setMostrar8] = useState(false);
  const [mostrar10, setMostrar10] = useState(false);
  const [catalogoProve, setCatalogoProve] = useState(false);

  const [activate, setActivate] = useState(false);

  const [deshabilitado] = useState(false);
  const [habiCod, setHabicod] = useState(true);
  const [habiProv, setHabiProv] = useState(true);
  const [habiMonto, setHabiMonto] = useState(true);
  const [habiRef, setHabiRef] = useState(false);
  const [habiTabs, setHabiTabs] = useState(false);
  const [visiRef, setVisiRef] = useState(true);
  const [visiAnio, setVisiAnio] = useState(true);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [datospre, setDatospre] = useState([]);
  const [cuentasCompro, setCuentasCompro] = useState([]);
  const [datosFac, setDatosFac] = useState([]);
  const [datosRet, setDatosRet] = useState([]);
  const [datosIsrl, setDatosIsrl] = useState([]);
  const [itemSelect, setItemSelect] = useState(-1);
  const [valida, setValida] = useState(0);
  const [depart, setDepart] = useState(null);
  const [tip, setTip] = useState(null);
  const [tipoComp, setTipoComp] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [pucc, setPucc] = useState(0);
  const [tituloapro, setTituloapro] = useState("");
  const [cambioDatos, setCambioDatos] = useState(false);
  const [data, setData] = useState([]);
  const [dataFac, setDataFac] = useState([]);
  const [dataRet, setDataRet] = useState([]);
  const [dataIsrl, setDataIsrl] = useState([]);
  const [body, setBody] = useState(null);
  const [codigo, setCodigo] = useState(0);
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [montoCompro] = useState(0.0);
  const [monaCompro, setMonaCompro] = useState(0.0);
  const [reteIslr, setReteIslr] = useState(0.0);
  const [totalRetenido, setTotalRetenido] = useState(0.0);
  const [totalFactura, setTotalFactura] = useState(0.0);
  const [totalCausar, setTotalCausar] = useState(0.0);
  const [totalBaseImpo, setTotalBaseImpo] = useState(0.0);
  const [fecha] = useState(null);
  const [fechaRev, setFechaRev] = useState(null);
  const [llamado, setLlamado] = useState(0);
  const [cambiarDatos, setCambiarDatos] = useState(false);
  const [mostrarUsuario, setMostrarUsuario] = useState(false);
  const [natural, setNatural] = useState(false);
  const [tipo, setTipo] = useState(0);
  const [exento, setExento] = useState(false);
  const [ultimo, setUltimo] = useState(false);
  const [idOrden, setIdOrden] = useState();
  const [idFondo, setIdFondo] = useState();
  const [desde, setDesde] = useState(0);
  const [habiConcep, setHabiConcep] = useState(false);
  const [habiFecha, setHabiFecha] = useState(false);
  const [canReten, setCanReten] = useState(0);
  // const [amortizacion, setAmortizacion] = useState(0.00);
  const [modifi, setModifi] = useState(false);
  const [proce, setProce] = useState(false);
  const [modifi1, setModifi1] = useState(false);
  const [proce1, setProce1] = useState(false);
  const [proce2, setProce2] = useState(false);
  const [buscarC, setBuscarC] = useState(false);
  const [habiBuscarC, setHabiBuscarC] = useState(false);
  const [condicion, setCondicion] = useState();
  const [idEfixPagar, setIdEfixPagar] = useState();
  const [numeroCheque, setNumeroCheque] = useState();
  const [idCtaBanc, setIdCtaBanc] = useState();
  const [ejercicio, setEjercicio] = useState();
  // const [tipoPago, setTipoPago] = useState();
  const [idMovBancario, setIdMovBancario] = useState();
  const [idMovBancarioDeb, setIdMovBancarioDeb] = useState();
  const [idDebito, setIdDebito] = useState();

  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const btnAcepta = useRef();
  const txtCodigo = useRef();
  const txtFechaOP = useRef();
  const txtObservacionOP = useRef();
  const txtNp = useRef();
  const txtIdprov = useRef();
  const txtCedurifprov = useRef();
  const txtNombreprov = useRef();
  const cmbTipoOrden = useRef();
  const txtReferencia = useRef();
  const cmbAnio = useRef();
  const txtConcepto = useRef();
  const txtMontoOrden = useRef();
  const txtMontoFondo = useRef();
  // const txtBanco = useRef();
  const txtSaldoFondoAvance = useRef();
  // const txtTotalPagar = useRef();

  useEffect(() => {
    seleccionarEfiscal();
  }, []);

  const onChange = (e) => {
    if (e.target.name === "tipo") {
      txtSaldoFondoAvance.current.value = "0,00";
      txtFechaOP.current.value = "";
      txtIdprov.current.value = "";
      txtReferencia.current.value = "";
      txtCedurifprov.current.value = "";
      txtNombreprov.current.value = "";
      txtConcepto.current.value = "";
      txtObservacionOP.current.value = "";
      txtMontoOrden.current.value = "";
      txtFechaOP.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
      blanquearTablas();
      setBuscarC(false);
      setHabiBuscarC(false);
      setTabs({
        tab1: "tab-pane fade show active",
        tab3: "tab-pane",
        tab4: "tab-pane",
      });
      setHabiTabs(false);
      desHabilitarCampos();
      if (cmbTipoOrden.current.value === "3") {
        setVisiRef(false);
        setVisiAnio(false);
        habilitarCampos();
        txtIdprov.current.value = idProv;
        seleccionarProveedor(idProv);
        setHabiMonto(true);
        setHabiProv(false);
        setHabiTabs(true);
      } else if (cmbTipoOrden.current.value === "2") {
        setHabiProv(false);
        setVisiRef(true);
        setHabiRef(true);
        setVisiAnio(false);
      } else if (cmbTipoOrden.current.value === "1") {
        setVisiRef(true);
        setHabiRef(true);
        setVisiAnio(true);
        setHabiProv(false);
        cmbAnio.current.value = anio[0].anio;
      } else if (
        cmbTipoOrden.current.value === "6" ||
        cmbTipoOrden.current.value === "10"
      ) {
        setVisiRef(true);
        setHabiRef(true);
        setHabiProv(false);
        setVisiAnio(false);
        setHabiBuscarC(false);
        setBuscarC(true);
      } else if (cmbTipoOrden.current.value === "0") {
        setVisiRef(true);
        setHabiRef(true);
        setVisiAnio(false);
        setHabiProv(false);
      } else if (cmbTipoOrden.current.value === "7") {
        if (espiritu >= 0) {
          setVisiRef(true);
          setHabiRef(true);
          setVisiAnio(false);
          setHabiProv(true);
          habilitarCampos();
          setHabiMonto(true);
        } else {
          setVisiRef(false);
          setVisiAnio(false);
          setHabiProv(true);
          habilitarCampos();
        }
      } else if (cmbTipoOrden.current.value === "") {
        desHabilitarCampos();
        setVisiRef(false);
        setVisiAnio(false);
        setHabiProv(false);
      } else {
        setVisiRef(false);
        setVisiAnio(false);
        setHabiProv(true);
        habilitarCampos();
        setHabiTabs(true);
      }
    } else if (e.target.name === "idcompromiso") {
      blanquearDatosCompromiso();
    } else if (e.target.name === "referencia") {
      txtConcepto.current.value = "";
      txtIdprov.current.value = "";
      txtCedurifprov.current.value = "";
      txtNombreprov.current.value = "";
      setTotalCausar(0.0);
      txtMontoOrden.current.value = "0,00";
      setMonaCompro(0.0);
      if (txtMontoFondo && txtMontoFondo.current) {
        txtMontoFondo.current.value = "0,00";
      }
      blanquearTablas();
      setIdEfixPagar(0);
    } else if (e.target.name === "idprove") {
      txtCedurifprov.current.value = "";
      txtNombreprov.current.value = "";
    }
  };
  const habilitarCampos = () => {
    setHabiFecha(true);
    setHabiProv(true);
    setHabiConcep(true);
    setHabiMonto(true);
    txtMontoOrden.current.value = "0,00";
  };
  const desHabilitarCampos = () => {
    setHabiFecha(false);
    setHabiProv(false);
    setHabiConcep(false);
    setHabiMonto(false);
  };
  const blanquearDatosCompromiso = () => {
    cmbTipoOrden.current.value = "";
    setHabiRef(false);
    txtReferencia.current.value = "";
    txtConcepto.current.value = "";
    txtIdprov.current.value = "";
    setExento(false);
    txtCedurifprov.current.value = "";
    txtNombreprov.current.value = "";
    setTotalCausar(0.0);
    txtMontoOrden.current.value = "0,00";
    setMonaCompro(0.0);
    if (txtMontoFondo && txtMontoFondo.current) {
      txtMontoFondo.current.value = "0,00";
    }
    setDatospre([]);
    setCuentasCompro([]);
    setDatosFac([]);
    setDatosRet([]);
    setDatosIsrl([]);
    setTipoComp(null);
  };
  const blanquearDatosOrden = () => {
    txtReferencia.current.value = "";
    txtConcepto.current.value = "";
    txtObservacionOP.current.value = "";
    txtIdprov.current.value = "";
    setExento(false);
    txtCedurifprov.current.value = "";
    txtNombreprov.current.value = "";
    setTotalCausar(0.0);
    txtMontoOrden.current.value = "0,00";
    setMonaCompro(0.0);
    if (txtMontoFondo && txtMontoFondo.current) {
      txtMontoFondo.current.value = "0,00";
    }
    setDatospre([]);
    setDatosFac([]);
    setDatosRet([]);
    setDatosIsrl([]);
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El código de la Orden de Pago no debe estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (cmbTipoOrden.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Tipo de Orden",
        icono: "informacion",
      });
      sigue = false;
      cmbTipoOrden.current.focus();
    } else if (
      (cmbTipoOrden.current.value.trim() === "0" ||
        cmbTipoOrden.current.value.trim() === "1" ||
        cmbTipoOrden.current.value.trim() === "2" ||
        cmbTipoOrden.current.value.trim() === "6" ||
        cmbTipoOrden.current.value.trim() === "7" ||
        cmbTipoOrden.current.value.trim() === "10") &&
      txtReferencia.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Referencia no puede estar en blanco",
        icono: "informacion",
      });
      sigue = false;
      cmbTipoOrden.current.focus();
    } else if (txtCedurifprov.current.value.trim() === "") {
      setTabs({
        tab1: "tab-pane fade show active",
        tab3: "tab-pane",
        tab4: "tab-pane",
      });
      sigue = false;
      setTimeout(() => {
        txtIdprov.current.focus();
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar el Proveedor",
          icono: "informacion",
        });
      }, 50);
    } else if (txtFechaOP.current.value.trim() === "") {
      setTabs({
        tab1: "tab-pane fade show active",
        tab3: "tab-pane",
        tab4: "tab-pane",
      });
      sigue = false;
      setTimeout(() => {
        txtFechaOP.current.focus();
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar la Fecha",
          icono: "informacion",
        });
      }, 50);
    }else if (
      new Date(txtFechaOP.current.value).getFullYear() !== anioefis) {
      setTabs({
        tab1: "tab-pane fade show active",
        tab3: "tab-pane",
        tab4: "tab-pane",
      });
      sigue = false;
      setTimeout(() => {
        txtFechaOP.current.focus();
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto:
            "El año no debe ser diferente al año del Ejercicio Fiscal actual",
          icono: "informacion",
        });
      }, 50);
    } else if (txtConcepto.current.value.trim() === "") {
      setTabs({
        tab1: "tab-pane fade show active",
        tab3: "tab-pane",
        tab4: "tab-pane",
      });
      sigue = false;
      setTimeout(() => {
        txtConcepto.current.focus();
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "El concepto de la Orden de Pago no puede estar en blanco",
          icono: "informacion",
        });
      }, 50);
    } else if (txtMontoOrden.current.value.trim() === "") {
      setTabs({
        tab1: "tab-pane fade show active",
        tab3: "tab-pane",
        tab4: "tab-pane",
      });
      sigue = false;
      setTimeout(() => {
        txtMontoOrden.current.focus();
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "El monto de la Orden de Pago no debe estar vacio",
          icono: "informacion",
        });
      }, 50);
    } else if (txtMontoOrden.current.value.trim() === "0,00") {
      setTabs({
        tab1: "tab-pane fade show active",
        tab3: "tab-pane",
        tab4: "tab-pane",
      });
      sigue = false;
      setTimeout(() => {
        txtMontoOrden.current.focus();
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "El monto de la Orden de Pago no debe ser igual a Cero(0,00))",
          icono: "informacion",
        });
      }, 50);
    } else if (
      (cmbTipoOrden.current.value.trim() === "6" ||
        cmbTipoOrden.current.value.trim() === "10") &&
      txtReferencia.current.value.trim() !== ""
    ) {
      if (
        parseFloat(
          txtMontoOrden.current.value.replace(/\./g, "").replace(",", ".")
        ) >
          parseFloat(
            txtSaldoFondoAvance.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) &&
        props.operacion === 1
      ) {
        setTabs({
          tab1: "tab-pane fade show active",
          tab3: "tab-pane",
          tab4: "tab-pane",
        });
        sigue = false;
        setTimeout(() => {
          txtMontoOrden.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "El monto de la orden no puede ser mayor al saldo restante del fondo de avance",
            icono: "informacion",
          });
        }, 50);
      } else if (
        parseFloat(totalFactura) !==
          parseFloat(
            txtMontoOrden.current.value.replace(/\./g, "").replace(",", ".")
          ) &&
        dataFac.length > 0
      ) {
        setTabs({
          tab1: "tab-pane fade show active",
          tab3: "tab-pane",
          tab4: "tab-pane",
        });
        sigue = false;
        setTimeout(() => {
          txtFechaOP.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "El Total de las Facturas debe ser igual\nal Monto de la Orden",
            icono: "informacion",
          });
        }, 50);
      }
    }
    if (sigue) {
      if (props.operacion === 1) {
        if (ultimo + 1 !== parseInt(txtCodigo.current.value)) {
          setDesde(4);
          setMensajesino({
            mostrar: true,
            titulo: "Confirmación.",
            texto:
              "El Código de la Orden no corresponde al proximo número disponible, Desea Continuar?",
            icono: "confirmacion",
          });
        } else {
          crearreversar();
        }
      } else {
        crearreversar();
      }
    }
  };

  const crearreversar = () => {
    let datosorden = [];
    datosorden.push({
      concepto: txtConcepto.current.value,
      referencia: txtReferencia.current.value,
      idproveedor: txtIdprov.current.value,
      observ: txtObservacionOP.current.value,
      montoorden: parseFloat(
        txtMontoOrden.current.value.replace(/\./g, "").replace(",", ".")
      ),
    });
    setBody({
      operacion: props.operacion,
      idordenp: txtCodigo.current.value,
      idorden: idOrden,
      norden: props.norden,
      idefi: idefiscal,
      idusuario: idusuario,
      clase: cmbTipoOrden.current.value,
      fecha: txtFechaOP.current.value,
      espiritu: espiritu,
      ejercicio: ejercicio,
      fechasis: fechaSistema,
      numerocheque: numeroCheque,
      numcaja: numCaja,
      iddebicre: idDebito,
      idmovbancariodeb: idMovBancarioDeb,
      idcuentaban: idCtaBanc,
      idefixpagar: idEfixPagar,
      datosordenp: datosorden,
      datosfactu: dataFac,
      datosrete: dataRet,
      datosreteislr: dataIsrl,
    });
    let msg = "";
    setDesde(0);
    if (props.operacion === 1) {
      msg = "Esta Seguro de Registrar estos Datos?.";
    } else if (props.operacion === 2) {
      msg = "Esta Seguro de Reversar esta Orden de Pago?.";
    } else if (props.operacion === 3) {
      msg = "Esta Seguro de Eliminar esta Orden de Pago?.";
    }
    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: msg,
      icono: "confirmacion",
    });
  };
  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/administracion/crearreversarordenpagofinanciera`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setDesde(2);
            setMensajesino({
              mostrar: true,
              titulo: "Confirmación.",
              texto: "Desea Imprimir En este Momento la Orden de Pago?",
              icono: "confirmacion",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Orden de Pago " +
                txtCodigo.current.value +
                " Reversada Correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Orden de Pago " +
                txtCodigo.current.value +
                " Eliminada Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquearTablas = () => {
    setItemSelect(-1);
    setDatosFac([]);
    setDataFac([]);
    setDatosRet([]);
    setDataRet([]);
    setDatosIsrl([]);
    setDataIsrl([]);
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setCuentasCompro([]);
    setDatosFac([]);
    setDatosRet([]);
    setDatosIsrl([]);
    setActivate(false);
    setChek(0);
    setValida(0);
    setDepart(null);
    setTip(null);
    setUbi(null);
    setPucc(0);
    setData([]);
    setDataFac([]);
    setDataRet([]);
    setDataIsrl([]);
    setTipoComp(null);
    setTipo(null);
    setBody(null);
    setCodigo(0);
    setTituloapro("");
    setActivo(true);
    setHabicod(true);
    setHabiProv(true);
    setHabiMonto(true);
    setHabiRef(false);
    setHabiFecha(false);
    setHabiConcep(false);
    setCambioDatos(false);
    setModifi(false);
    setProce(false);
    setModifi1(false);
    setProce1(false);
    setProce2(false);
    setDesde(0);
    setItemSelect(-1);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
    } else if (desde === 2) {
      imprimirOrdenPago();
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto:
          "Orden de Pago " +
          txtCodigo.current.value +
          " Registrada Correctamente",
        icono: "exito",
      });
    } else if (desde === 3) {
      imprimirOrdenPago();
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto: "Orden de Pago Registrada Correctamente",
        icono: "exito",
      });
    } else if (desde === 4) {
      crearreversar();
    } else {
      Actualizar();
    }
  };

  const handleCloseNo = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 2) {
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto:
          "Orden de Pago " +
          txtCodigo.current.value +
          " Registrada Correctamente",
        icono: "exito",
      });
    } else if (desde === 4) {
      txtCodigo.current.focus();
    }
  };

  const imprimirOrdenPago = () => {
    var reporte = "";
    if (props.norden) {
      reporte = "ForPagoFinancieraNumOrdenAraure";
    } else {
      reporte = "ForPagoFinanciera";
    }
    var sql = "";
    var sql2 = "0";
    var sql1 =
      numeroaLetra(txtMontoOrden.current.value.trim().replace(/\./g, "")) +
      " Bs.";
    sql = idOrden;
    window.open(
      op.reportes +
        "/administracionTesoreria?" +
        "reporte=" +
        reporte +
        "&ID=" +
        sql +
        "&ENLETRAS=" +
        sql1 +
        "&VALIDO=" +
        sql2 +
        "&VIENE=" +
        espiritu +
        "&EFISCAL=" +
        idefiscal +
        "&USUARIO=" +
        liquidador.trim(),
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const BaseDatosFac = (data, index, ope, numfact) => {
    let totalF = 0.0;
    let totalB = 0.0;
    for (let i = 0; i < data.length; i++) {
      totalF = parseFloat(totalF) + parseFloat(data[i].total);
      totalB = parseFloat(totalB) + parseFloat(data[i].baseimponible);
    }
    totalF = Math.round(parseFloat(totalF) * Math.pow(10, 4)) / Math.pow(10, 4);
    totalB = Math.round(parseFloat(totalB) * Math.pow(10, 4)) / Math.pow(10, 4);
    setTotalFactura(totalF);
    setTotalBaseImpo(totalB);
    setDataFac(data);
    setItemSelect(index);
    if (ope === 2) {
      setDataRet(
        dataRet.filter((it) => it.numfactura !== data[index].numfactura)
      );
      setDatosRet(
        dataRet.filter((it) => it.numfactura !== data[index].numfactura)
      );
    } else if (ope === 3) {
      setDataRet(dataRet.filter((it) => it.numfactura !== numfact));
      setDatosRet(dataRet.filter((it) => it.numfactura !== numfact));
    } else {
      if (desde === 5) {
        if (index < 0) {
          setItemSelect(0);
        }
        setDatosRet(dataRet);
      } else {
        setDatosRet(dataRet);
      }
    }
    if (ope === 1 || ope === 3) {
      setItemSelect(index);
      setDatosFac(data);
    }
  };

  const BaseDatosRet = (data) => {
    let total = 0.0;
    let cont = 0;
    for (let i = 0; i < data.length; i++) {
      total = parseFloat(total) + parseFloat(data[i].totalrete);
      cont++;
    }
    setCanReten(cont);
    total = Math.round(parseFloat(total) * Math.pow(10, 4)) / Math.pow(10, 4);
    setTotalRetenido(total);
    setDataRet(data);
  };

  const BaseDatosIsrl = (data) => {
    setDataIsrl(data);
  };

  const catalogoProveedor = (e) => {
    e.preventDefault();
    setCatalogoProve(true);
  };

  const validarProveedor = (idprov, idcdprov, nomb) => {
    setCatalogoProve(false);
    txtIdprov.current.value = idprov;
    seleccionarProveedor(idprov);
  };

  const catalogoConceptoFondo = (e) => {
    e.preventDefault();
    setMostrar10(true);
  };

  const handleAceptaConceptoFondo = (idfondo, descripcion) => {
    txtObservacionOP.current.value = descripcion.trim();
    setMostrar10(false);
  };

  const handleCancelaConceptoFondo = () => {
    setMostrar10(false);
  };

  const seleccionarEfiscal = () => {
    setActivate(true);
    let campos = "*";
    let nomtab = "efiscal";
    let orden = "anio desc";
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          var anio = [];
          var idEf = [];
          for (let i = 0; i < response.data.length; i++) {
            anio.push({
              anio: response.data[i].anio,
            });
            idEf.push({
              idefiscal: response.data[i].idefiscal,
            });
          }
          setIdEfis(idEf);

          const newArr = anio.map((item) => ({
            value: item.anio,
            label: item.anio,
          }));
          setAnio(newArr);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRetencionesOrdenPago = (id, idefi) => {
    let endpoint = `${op.conexion}/api/administracion/seleccionarretencionesordenpago?idefi=${idefi}&&idordenp=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let nFac = response.data[0].numfactura;
            let datosFactu = [];
            for (let i = 0; i < response.data.length; i++) {
              if (i === 0 || nFac !== response.data[i].numfactura) {
                datosFactu.push({
                  idfacturaxorden: response.data[i].idfacturaxorden,
                  numoperacion: response.data[i].codoperacion,
                  numfactura: response.data[i].numfactura,
                  numcontrol: response.data[i].numcontrol,
                  fecfactura: response.data[i].fecfactura,
                  subtotal: response.data[i].subtotal,
                  otros: response.data[i].otros,
                  ajuste: response.data[i].ajuste,
                  exento: response.data[i].exento,
                  baseimponible: response.data[i].baseimponible,
                  porceiva: response.data[i].porceiva,
                  total: response.data[i].total,
                });
              }
              nFac = response.data[i].numfactura;
            }
            setDataFac(response.data);
            setDatosFac(datosFactu);
            if (response.data[0].iddetalle !== null) {
              setDataRet(response.data);
              setDatosRet(response.data);
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SeleccionarRetencionesIsrlOrdenPago = (id, idefi) => {
    let endpoint = `${op.conexion}/api/administracion/seleccionarretencionisrlordenpago?idefi=${idefi}&&idordenp=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setDataIsrl(response.data);
            setDatosIsrl(response.data);
          } else {
            setDataIsrl([]);
            setDatosIsrl([]);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarProveedor = (codigo) => {
    let campos = "*";
    let nomtab = "proveedor";
    let nomid = "idproveedor";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idproveedor > 0) {
            txtIdprov.current.value = response.data.idproveedor;
            txtCedurifprov.current.value = response.data.rif;
            txtNombreprov.current.value = response.data.razonsocial;
            setExento(response.data.exentoiva);
            //setMontoIslr(response.data.retencionislr);
            setReteIslr(response.data.retencionislr);
            if (
              parseInt(response.data.denominacioncomercial) === 9 ||
              parseInt(response.data.denominacioncomercial) === 7
            ) {
              setNatural(true);
            } else {
              setNatural(false);
            }
            if (habiFecha) {
              txtFechaOP.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Proveedor no existe.",
              icono: "informacion",
            });
            txtIdprov.current.value = "";
            txtCedurifprov.current.value = "";
            txtNombreprov.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionaUltimoId = () => {
    let campos =
      (props.norden ? "numordenpago" : "idordenpago") + " AS ultimoid";
    let nomtab = "ordenpago";
    let condi =
      "idefiscal=" +
      idefiscal +
      (props.norden ? " AND (tipo = 2 OR tipo = 3)" : "");
    let orden =
      (props.norden ? "numordenpago" : "idordenpago") + " DESC LIMIT 1";
    let endpoint =
      op.conexion +
      `/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setUltimo(parseInt(response.data[0].ultimoid));
            setHabicod(false);
            txtCodigo.current.value = parseInt(response.data[0].ultimoid) + 1;
          } else {
            setUltimo(0);
            setHabicod(false);
            txtCodigo.current.value = 1;
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarIdOrden = () => {
    let campos = "idordenpago";
    let nomtab = "ordenpago";
    let condi = "idefiscal=" + idefiscal;
    let orden = "idordenpago DESC LIMIT 1";
    let endpoint =
      op.conexion +
      `/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setIdOrden(parseInt(response.data[0].idordenpago) + 1);
          } else {
            setIdOrden(parseInt(1));
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleInputNumChange = (event) => {
    //setActiveIndex(1);
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.name === "idprove") {
          txtFechaOP.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  // const eliminarRetenciones = () => {
  // }
  const eliminarRetencionesIslr = () => {
    setDatosIsrl([]);
    setDataIsrl([]);
  };
  const cambiarConcepto = () => {
    setDesde(0);
    setMostrarUsuario(true);
  };
  const editarFactura = () => {
    if (props.ordenp.poseecheque === 0) {
      setDesde(5);
      setMostrarUsuario(true);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto:
          "No se pueden modificar las Retenciones ya que la orden de pago posee egreso realizado",
        icono: "error",
      });
    }
  };

  const aceptaClaveSupervisor = () => {
    setMostrarUsuario(false);
    if (desde === 0) {
      setModifi(false);
      setProce(true);
      setModifi1(false);
      setProce1(false);
      setProce2(false);
      setHabiConcep(false);
      setHabiFecha(true);
      setHabiConcep(true);
      setHabicod(false);
    } else if (desde === 1) {
      setLlamado(3);
      setCambiarDatos(true);
    } else if (desde === 5) {
      setModifi1(false);
      setProce1(true);
      setModifi(false);
      setProce(false);
      setProce2(true);
    }
  };

  const aceptaCambioDatos = (codigo, fecha, llamado) => {
    setCambiarDatos(false);
    setFechaRev(fecha);
  };

  const handleProveedor = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProveedor(event.target.value);
      }
    }
  };

  const seleccionarReferencia = () => {
    let tip = parseInt(cmbTipoOrden.current.value);
    switch (tip) {
      case 0:
        setMostrar1(true);
        break;
      case 1:
        setMostrar4(true);
        break;
      case 2:
        setMostrar2(true);
        break;
      case 6:
      case 10:
        setCondicion(
          "idefiscal = " + idefiscal + " AND tipofondo = " + (tip === 6 ? 0 : 1)
        );
        setMostrar7(true);
        break;
      case 7:
        setMostrar8(true);
        break;
    }
  };
  const handleAceptaPagadoReposi = (idchequeemitido, portador) => {
    setMostrar4(false);
    blanquearDatosOrden();
    blanquearTablas();
    txtReferencia.current.value = idchequeemitido;
    seleccionarCheque(idchequeemitido);
  };

  const seleccionarCheque = (id) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/administracion/seleccionarcheque?idcheque=${id}&idefi=${idefiscal}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtConcepto.current.value =
            response.data.concepto === null
              ? ""
              : response.data.concepto.trim();
          txtIdprov.current.value = response.data.idproveedor;
          txtMontoOrden.current.value =
            response.data.fechaemi < "2018-08-20"
              ? formatMoneda(
                  (response.data.montocheque / 100000.0)
                    .toString()
                    .replace(",", "")
                    .replace(".", ","),
                  ",",
                  ".",
                  2
                )
              : formatMoneda(
                  response.data.montocheque
                    .toString()
                    .replace(",", "")
                    .replace(".", ","),
                  ",",
                  ".",
                  2
                );
          txtObservacionOP.current.value =
            "REPOSICIÓN DEL CHEQUE Nº " + response.data.numerocheque;
          setEjercicio(response.data.ejercicio);
          setNumeroCheque(response.data.numerocheque);
          setIdMovBancario(response.data.idmovimientobancario);
          setIdCtaBanc(response.data.idcuentabancaria);
          setHabiConcep(true);
          setHabiFecha(true);
          seleccionarProveedor(response.data.idproveedor);
          setHabiTabs(true);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };
  const handleAceptaOrdenPagoxPagar = (
    numordenpago,
    razonsocial,
    idproveedor,
    ubicacion,
    fecha,
    idcompromiso,
    idordenpago,
    tipo,
    concepto,
    idefis
  ) => {
    setMostrar8(false);
    blanquearDatosOrden();
    blanquearTablas();
    setIdEfixPagar(idefis);
    txtReferencia.current.value = numordenpago;
    seleccionarOrdenPagoxPagar(numordenpago, idefis);
  };

  const handleCancelaOrdenPagoxPagar = () => {
    setMostrar8(false);
  };

  const seleccionarOrdenPagoxPagar = (id, idefi) => {
    setActivate(true);
    let campos = "*";
    let nomtab = "ordenpagoxpagar";
    let nomid = "idefiscal";
    let condic = "numordenpago = " + id + " AND tipo = 0";
    let endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${idefi}&nomtab=${nomtab}&nomid=${nomid}&condic=${condic}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (
            parseInt(response.data[0].conorden) === 1 &&
            props.operacion !== 4
          ) {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "La orden de pago ya tiene Orden de Pago Financiera.",
              icono: "informacion",
            });
            txtReferencia.current.value = "";
            return;
          }
          habilitarCampos();
          txtConcepto.current.value =
            response.data[0].conceptoorden === null
              ? ""
              : response.data[0].conceptoorden.trim();
          txtObservacionOP.current.value = response.data[0].observacion.trim();
          txtIdprov.current.value = response.data[0].idproveedororden;
          seleccionarProveedor(response.data[0].idproveedororden);
          txtMontoOrden.current.value = formatMoneda(
            (response.data[0].montoordenpago - response.data[0].abonado)
              .toString()
              .replace(",", "")
              .replace(".", ","),
            ",",
            ".",
            2
          );
          setHabiProv(false);
          setHabiMonto(false);
          setHabiTabs(true);
          seleccionarRetencionesOrdenPago(response.data[0].idordenpago, idefi);
          SeleccionarRetencionesIsrlOrdenPago(
            response.data[0].idordenpago,
            idefi
          );
        }
      })
      .catch(function (error) {
        txtReferencia.current.value = "";
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };
  const handleAceptarFondos = (
    idfondo,
    descripcion,
    monto,
    responsable,
    tipofondo,
    idorganismo
  ) => {
    setMostrar7(false);
    blanquearDatosOrden();
    blanquearTablas();
    setIdFondo(idfondo);
    txtReferencia.current.value = idfondo;
    seleccionarFondoAvance(txtReferencia.current.value, props.operacion);
  };

  const handleCancelaFondos = () => {
    setMostrar7(false);
  };

  const seleccionarFondoAvance = (id, ope) => {
    setActivate(true);
    let campos = "*";
    let nomtab = "fondoavance";
    let nomid = "idfondo";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtConcepto.current.value =
            response.data.descripcion === null
              ? ""
              : response.data.descripcion.trim();
          txtIdprov.current.value = response.data.idorganismo;
          setHabiConcep(true);
          setHabiFecha(true);
          setHabiMonto(true);
          if (props.operacion === 1) {
            setHabiBuscarC(true);
          } else {
            setHabiBuscarC(false);
          }
          seleccionarProveedor(response.data.idorganismo);
          seleccionarSaldoFondoAvance(id);
          setHabiTabs(true);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };
  const seleccionarSaldoFondoAvance = (id) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/presupuesto/seleccionarsaldofondoavance?idfondo=${id}&idefi=${idefiscal}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtSaldoFondoAvance.current.value = formatMoneda(
            response.data.saldo.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          txtMontoOrden.current.value = "0,00";
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };
  const handleCancelaPagadoReposi = () => {
    setMostrar4(false);
  };
  const handleAceptarSPagoObra1 = (
    idsolicitudpagoobras,
    idobraasignada,
    status,
    fecha,
    observaciones,
    tipo,
    concepto,
    idefiscal
  ) => {
    setMostrar2(false);
    blanquearDatosOrden();
    blanquearTablas();
    txtReferencia.current.value = idsolicitudpagoobras;
    seleccionarSPagoObra1(idsolicitudpagoobras);
  };
  const handleCancelaSPagoObra1 = () => {
    setMostrar2(false);
  };
  const seleccionarSPagoObra1 = (id) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/administracion/seleccionarsolicitudpagoobra?idefi=${idefiscal}&idsolicitud=${id}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (parseInt(response.data.status) === 0) {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto:
                "La Solicitud de Pago de Obra no ha sido enviada al Departamento de Administración.",
              icono: "informacion",
            });
            txtReferencia.current.value = "";
          } else if (parseInt(response.data.status) === 1) {
            habilitarCampos();
            txtConcepto.current.value =
              response.data.observaciones === null
                ? ""
                : response.data.observaciones.trim();
            txtMontoOrden.current.value = formatMoneda(
              response.data.monorden
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtIdprov.current.value = response.data.idproveedor;
            seleccionarProveedor(response.data.idproveedor);
            setHabiProv(false);
            setHabiMonto(false);
            setHabiTabs(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "La Solicitud de Pago de Obra ya fue Procesada.",
              icono: "informacion",
            });
            txtReferencia.current.value = "";
          }
        }
      })
      .catch(function (error) {
        txtReferencia.current.value = "";
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const handleAceptarFondosT = (idaprobacion, descripcion) => {
    setMostrar1(false);
    blanquearDatosOrden();
    blanquearTablas();
    txtReferencia.current.value = idaprobacion;
    seleccionarRetenciones(idaprobacion);
  };

  const handleCancelaFondosT = () => {
    setMostrar1(false);
  };

  const seleccionarRetenciones = (id) => {
    setActivate(true);
    let endpoint;
    if (props.operacion === 1) {
      endpoint = `${op.conexion}/api/administracion/seleccionarretencionesaprobadas?idaprob=${id}&idefi=${idefiscal}`;
    } else {
      endpoint = `${op.conexion}/api/administracion/seleccionarretencionesdepter?idcheque=${id}&idefi=${idefiscal}`;
    }

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            let conta = 0;
            for (let i = 0; i < response.data.length; i++) {
              conta = parseInt(conta) + 1;
              if (props.operacion == 1) {
                if (parseInt(response.data[i].ordenpagoaprob) > 0) {
                  txtReferencia.current.value = "";
                  txtIdprov.current.value = "";
                  txtCedurifprov.current.value = "";
                  txtNombreprov.current.value = "";
                  txtConcepto.current.value = "";
                  txtObservacionOP.current.value = "";
                  txtMontoOrden.current.value = "";
                  return;
                }
              }
              txtConcepto.current.value =
                response.data[i].descripaprobacion === null
                  ? ""
                  : response.data[i].descripaprobacion.trim();
              txtMontoOrden.current.value = formatMoneda(
                response.data[i].montototalaprob
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
            }
            setHabiConcep(true);
            setHabiFecha(true);
            setHabiTabs(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "La Referencia no existe.",
              icono: "informacion",
            });
            txtReferencia.current.value = "";
            txtIdprov.current.value = "";
            txtCedurifprov.current.value = "";
            txtNombreprov.current.value = "";
            return;
          }
          txtIdprov.current.value = idProv;
          seleccionarProveedor(idProv);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };
  const validarModificarConcepto = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Código de la Orden de Pago no debe estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtFechaOP.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFechaOP.current.focus();
    } else if (txtConcepto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El concepto de la Orden de Pago no puede estar en blanco",
        icono: "informacion",
      });
      sigue = false;
      txtConcepto.current.focus();
    } else if (
      new Date(txtFechaOP.current.value).getFullYear() !==
      anioefis
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFechaOP.current.focus();
    } 
    if (sigue) {
      let body = {
        idordenpnue: txtCodigo.current.value,
        idorden: idOrden,
        norden: props.norden,
        observ: txtObservacionOP.current.value,
        concepto: txtConcepto.current.value,
        dfecha: txtFechaOP.current.value,
        clase: cmbTipoOrden.current.value,
        referencia: txtReferencia.current.value,
        ejercicio: ejercicio,
        idefi: idefiscal,
        espiritu: espiritu,
        idusu: idusuario,
        fechasis: fechaSistema,
        dirip: ip === "" || ip === null ? "0.0.0.0" : ip,
        dirmac: mac === "" || mac === null ? "0.0.0.0" : mac,
      };
      procesarCambio(body);
    }
  };

  const procesarCambio = (body) => {
    let endpoint = `${op.conexion}/api/administracion/modificarconceptoordenpagof`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Se Generaron Cambios Satisfactoriamente",
            icono: "exito",
          });
          setModifi(true);
          setProce(false);
          setHabiConcep(false);
          setHabiFecha(false);
          setHabicod(true);
          setCambioDatos(true);
          if (!props.norden) {
            setIdOrden(txtCodigo.current.value);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    if (cambioDatos) {
      blanquear();
      props.onHideRenderizar();
      props.onHideCancelar();
    } else {
      blanquear();
      props.onHideCancelar();
    }
  };

  const onTabs = (indice) => (e) => {
    let op = indice;
    if (op === 1) {
      setTabs({
        tab1: "tab-pane fade show active",
        tab3: "tab-pane",
        tab4: "tab-pane",
      });
    } else if (op === 3) {
      setTabs({
        tab3: "tab-pane fade show active",
        tab1: "tab-pane",
        tab4: "tab-pane",
      });
    } else if (op === 4) {
      setTabs({
        tab4: "tab-pane fade show active",
        tab1: "tab-pane",
        tab3: "tab-pane",
      });
    }

    if (!habiTabs) {
      setTimeout(() => {
        setTabs({
          tab1: "tab-pane fade show active",
          tab3: "tab-pane",
          tab4: "tab-pane",
        });
      }, 100);
    }
  };

  const validarModificarRetenciones = (e) => {
    e.preventDefault();
    var sigue = true;
    if (
      parseFloat(totalFactura) !==
      parseFloat(
        txtMontoOrden.current.value.replace(/\./g, "").replace(",", ".")
      )
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Total de las Facturas debe ser igual\nal Monto de la Orden",
        icono: "informacion",
      });
      sigue = false;
    }
    if (sigue) {
      modificarRetenciones();
    }
  };

  const modificarRetenciones = () => {
    let body = {
      operacion: props.operacion,
      idorden: idOrden,
      idefi: idefiscal,
      montoordenpago: parseFloat(
        txtMontoOrden.current.value.replace(/\./g, "").replace(",", ".")
      ),
      datosfactu: dataFac,
      datosrete: dataRet,
      datosreteislr: dataIsrl,
    };
    let endpoint = `${op.conexion}/api/administracion/guardarfacturasyretencionesopf`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Las Retenciones se Realizaron con Exito",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.target.id === "montoorden") {
        setTotalCausar(
          parseFloat(event.target.value.replace(/\./g, "").replace(",", "."))
        );
        if (event.which === 13) {
          btnAcepta.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setModifi(false);
        setModifi1(false);
        setTabs({
          tab1: "tab-pane fade show active",
          tab3: "tab-pane",
          tab4: "tab-pane",
        });
        if (props.operacion !== 1) {
          setHabicod(true);
          if (props.operacion === 4 && props.ordenp.reversado === 0) {
            setModifi(true);
            setModifi1(true);
          }
          setHabiMonto(false);
          setBuscarC(false);
          setHabiTabs(true);
          cmbTipoOrden.current.value = props.ordenp.claseorden;
          setVisiAnio(false);
          if (
            props.ordenp.claseorden === 0 ||
            props.ordenp.claseorden === 1 ||
            props.ordenp.claseorden === 2 ||
            props.ordenp.claseorden === 6 ||
            props.ordenp.claseorden === 7 ||
            props.ordenp.claseorden === 10
          ) {
            if (props.ordenp.reversado === 1) {
              setVisiRef(false);
            } else {
              setVisiRef(true);
            }

            setHabiRef(false);
            if (props.ordenp.claseorden === 1) {
              setVisiAnio(true);
            }
          } else {
            setVisiRef(false);
          }
          setIdDebito(props.ordenp.iddebito);
          setEjercicio(props.ordenp.ejercicio);
          setNumeroCheque(props.ordenp.numerocheque);
          setIdMovBancarioDeb(props.ordenp.idmovimientobancariodeb);
          setIdCtaBanc(props.ordenp.idcuentabancaria);
          setIdMovBancario(props.ordenp.idmovimientobancario);
          setHabiFecha(false);
          setHabiConcep(false);
          setHabiProv(false);
          setHabiRef(false);
          setValues(props.ordenp);
          txtCodigo.current.value = props.ordenp.idorden;
          setCodigo(props.ordenp.idordenpago);
          setIdOrden(props.ordenp.idordenpago);
          txtFechaOP.current.value = moment.utc(props.ordenp.fechaorden).format(
            "YYYY-MM-DD"
          );
          txtObservacionOP.current.value = props.ordenp.observacionorden;
          txtConcepto.current.value = props.ordenp.conceptoorden;
          txtReferencia.current.value = props.ordenp.referencia;
          txtIdprov.current.value = props.ordenp.idproveedor;
          txtMontoOrden.current.value = formatMoneda(
            props.ordenp.montoorden
              .toString()
              .replace(",", "")
              .replace(".", ","),
            ",",
            ".",
            2
          );
          seleccionarProveedor(props.ordenp.idproveedor);
          seleccionarRetencionesOrdenPago(props.ordenp.idordenpago, idefiscal);
          SeleccionarRetencionesIsrlOrdenPago(
            props.ordenp.idordenpago,
            idefiscal
          );
        } else {
          seleccionaUltimoId();
          seleccionarIdOrden();
          setHabiMonto(false);
          setHabiProv(false);
          setHabiConcep(false);
          setHabiFecha(false);
          setTotalFactura(0.0);
          txtFechaOP.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
          setVisiRef(false);
          setVisiAnio(false);
        }
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2">
        <h3 className="fs-4 fw-bold text-light m-0">
          {props.titulo +
            (props.operacion === 1 && ultimo
              ? ", Ultima procesada: " + ultimo
              : "")}
        </h3>
        <button className="btn btn-sm bg-light" onClick={cancelar}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div>
          <input type="hidden" ref={txtNp} />
          <fieldset className="col-12 border-azul rounded m-0 p-2 d-flex flex-wrap align-items-center justify-content-between">
            <legend className="float-none m-0 w-auto">Datos</legend>
            {props.ordenp && props.ordenp.reversado > 0 && (
              <div className="col-12 m-0 p-0 input-group input-group-sm">
                <font color="red" size="1">
                  <h1 align="center">
                    <i>¡ La Orden de Pago está Reversada !</i>
                  </h1>
                </font>
              </div>
            )}
            <div className="col-4 col-lg-2 m-0 mt-lg-4 p-0 pr-2">
              <Input
                label="Código:"
                onKeyUp={handleInputNumChange}
                disabled={habiCod}
                id="idordenpago"
                ref={txtCodigo}
              />
            </div>
            <fieldset className="col-12 col-lg-9 border-azul rounded p-2 m-0 d-flex flex-wrap align-items-center justify-content-between">
              <legend className="float-none m-0 w-auto fw-bold fs-6">
                Tipo de Orden
              </legend>
              <div className="col-7 col-lg-6 m-0 p-0 pr-2 pr-lg-0">
                <Select
                  label="Tipo de orden:"
                  disabled={
                    operacion === 4 || operacion === 2 || operacion === 3
                      ? true
                      : deshabilitado
                  }
                  onChange={onChange}
                  name="tipo"
                  options={[
                    { value: "", label: "--Seleccione--" },
                    { value: "0", label: "TRASLADO DE FONDOS DE TERCEROS" },
                    { value: "1", label: "REPOSICION DE CHEQUES" },
                    { value: "2", label: "ANATICIPOS DE OBRAS" },
                    { value: "3", label: "TRANSFERENCIAS BANCARIAS" },
                    { value: "4", label: "REINTEGROS" },
                    { value: "5", label: "APERTURA DE CAJA CHICA" },
                    { value: "6", label: "FONDO EN AVANCE" },
                    { value: "7", label: "CUENTAS POR PAGAR" },
                    { value: "8", label: "PROVEEDORES" },
                    { value: "9", label: "JUZGADO DE MENORES" },
                    { value: "10", label: "FONDO EN ANTICIPO" },
                  ]}
                  ref={cmbTipoOrden}
                />
              </div>
              <div
                className="col-5 col-lg-4 m-0 p-0"
                style={{ display: visiRef ? "flex" : "none" }}
              >
                <SearchInput
                  label="N° de Referencia:"
                  disabled={true}
                  autocomplete="off"
                  onChange={onChange}
                  name="referencia"
                  id="inputDireccion"
                  ref={txtReferencia}
                  disabledButton={!habiRef}
                  onClickButton={seleccionarReferencia}
                />
              </div>
              <div
                className="col-4 col-lg-3 m-0 mt-2 mt-lg-0 p-0"
                style={{ display: visiAnio ? "flex" : "none" }}
              >
                <Select
                  label="Año:"
                  name="idestado"
                  disabled={
                    operacion === 4 || operacion === 2 || operacion === 3
                      ? true
                      : deshabilitado
                  }
                  id="inputFechaReg"
                  options={anio}
                  ref={cmbAnio}
                />
              </div>
            </fieldset>
          </fieldset>
          <fieldset className="col-12 p-0 m-0 mt-2">
            <ul className="nav nav-tabs" id="ex-with-icons" role="tablist">
              <li className="nav-item" role="presentation">
                <a
                  onClick={onTabs(1)}
                  className="nav-link active"
                  id="tab1"
                  data-bs-toggle="tab"
                  type="button"
                  data-bs-target="#div1"
                  role="tab"
                  aria-controls="div1"
                  aria-selected="true"
                >
                  Detalles
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  onClick={onTabs(3)}
                  className="nav-link"
                  id="tab3"
                  data-bs-toggle="tab"
                  type="button"
                  data-bs-target="#div3"
                  role="tab"
                  aria-controls="div3"
                  aria-selected="false"
                >
                  Retención
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  onClick={onTabs(4)}
                  className="nav-link"
                  id="tab4"
                  data-bs-toggle="tab"
                  type="button"
                  data-bs-target="#div4"
                  role="tab"
                  aria-controls="div4"
                  aria-selected="false"
                >
                  Retención I.S.L.R
                </a>
              </li>
            </ul>
            <div className="tab-content py-1" id="myTabContent">
              <div
                className={tabs.tab1}
                id="div1"
                role="tabpanel"
                aria-labelledby="tab1"
              >
                <div className="col-12 p-0 m-0">
                  <fieldset className="col-12 p-2 m-0 border-azul rounded d-flex flex-wrap gap-2 justify-content-between">
                    <legend className="float-none m-0 w-auto fw-bold fs-6">
                      Beneficiario
                    </legend>
                    <div className="col-5 col-lg-2 p-0 m-0">
                      <SearchInput
                        label="Código:"
                        disabled={!habiProv}
                        onChange={onChange}
                        onKeyUp={handleProveedor}
                        onBlur={handleInputNumChange}
                        name="idprove"
                        id="inputDireccion"
                        onClickButton={catalogoProveedor}
                        disabledButton={!habiProv}
                        ref={txtIdprov}
                      />
                    </div>
                    <div className="col-5 col-lg-2 m-0 p-0">
                      <Input
                        label="RIF:"
                        disabled={true}
                        name="observacion"
                        id="inputDireccion"
                        ref={txtCedurifprov}
                      />
                    </div>
                    <div className="col-12 col-lg-7 p-0 m-0">
                      <Input
                        label="Razón Social:"
                        disabled={true}
                        name="observacion"
                        defaultValue={
                          props.aprobaciones
                            ? props.aprobaciones.idaprobaciones.trim()
                            : ""
                        }
                        id="inputDireccion"
                        ref={txtNombreprov}
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-12 p-0 m-0 mt-2 d-flex flex-wrap align-items-center gap-2">
                    <div className="col-6 col-lg-3 m-0 p-0 mr-auto">
                      <Input
                        label="Fecha Orden Pago:"
                        type="date"
                        disabled={!habiFecha}
                        defaultValue={
                          props.aprobaciones && props.aprobaciones.fecha !== ""
                            ? moment.utc(props.aprobaciones.fecha).format(
                                "YYYY-MM-DD"
                              )
                            : moment.utc(fechaSistema).format("YYYY-MM-DD")
                        }
                        id="inputDireccion"
                        ref={txtFechaOP}
                      />
                    </div>
                    <div className="col-12 p-0 m-0">
                      <Textarea
                        label="Observación Orden Pago:"
                        autoComplete="off"
                        style={{ height: 70 }}
                        name="observacion"
                        onChange={onChange}
                        disabled={!habiConcep}
                        defaultValue={
                          props.aprobaciones
                            ? props.aprobaciones.observaciones.trim()
                            : ""
                        }
                        placeholder="Descripción de la Observación"
                        id="inputDireccion"
                        ref={txtObservacionOP}
                      />
                      {modifi === true && (
                        <WarningButton
                          icon="fa-edit m-0"
                          onClick={cambiarConcepto}
                        ></WarningButton>
                      )}
                      {proce === true && (
                        <SuccessButton onClick={validarModificarConcepto}>
                          Procesar
                        </SuccessButton>
                      )}
                      {buscarC === true && (
                        <InfoButton
                          icon="fa-search m-0"
                          disabled={!habiBuscarC}
                          onClick={catalogoConceptoFondo}
                        ></InfoButton>
                      )}
                    </div>
                  </fieldset>
                  <div className="col-12 m-0 my-2 p-0">
                    <Textarea
                      label="Concepto/Detalle:"
                      type="textarea"
                      className="form-control text-uppercase bg-light"
                      style={{ height: 70 }}
                      name="observacion"
                      id="inputDireccion"
                      ref={txtConcepto}
                    />
                  </div>
                  <div className="col-12 p-0 m-0 d-flex flex-column align-items-end gap-2">
                    <div className="col-4 col-lg-3 m-0 p-0 text-end">
                      <Input label="Saldo de Fondo de Avance:"
                        inputClassName="text-end"
                        disabled={true}
                        id="idcompromiso"
                        defaultValue={"0,00"}
                        ref={txtSaldoFondoAvance}
                      />
                    </div>
                    <div className="col-4 col-lg-3 m-0 p-0">
                      <Input label="Monto de la Orden:"
                        inputClassName="text-end"
                        disabled={!habiMonto}
                        id="montoorden"
                        defaultValue={"0,00"}
                        onFocus={seleccionarCampo}
                        onBlur={handleInputMontoChange}
                        onKeyUp={handleInputMontoChange}
                        ref={txtMontoOrden}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={tabs.tab3}
                id="div3"
                role="tabpanel"
                aria-labelledby="tab3"
              >
                <fieldset className="row border-azul rounded mx-auto container mb-2">
                  <div className="col-sm-3 mb-1 px-0"></div>
                  <div className="col-sm-3 mb-1 px-0">
                    <div className="m-0 w-100">
                      {proce2 === true && (
                        <WarningButton
                          icon="fa-edit m-0"
                          onClick={() => {
                            setDesde(0);
                            setProce1(false);
                            setMostrar6(true);
                          }}
                        >
                          Modificar Factura
                        </WarningButton>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-4 mb-1 px-0"></div>
                  <div className="col-sm-2 mb-1 px-0">
                    <div className="input-group input-group-sm m-0 w-100">
                      {modifi1 === true && 
                        <WarningButton
                          icon="fa-edit m-0"
                          onClick={editarFactura}
                        ></WarningButton>
                      }
                      {proce1 === true &&
                        <SuccessButton
                          onClick={validarModificarRetenciones}
                        >
                            Procesar
                        </SuccessButton>
                      }
                    </div>
                  </div>
                  <legend className="float-none m-0 w-auto fw-bold">
                    Datos de la(s) Factura(s)
                  </legend>

                  <TablaFacturas
                    data={BaseDatosFac}
                    datarecords={datosFac}
                    operacion={operacion}
                    tipocomp={tipoComp}
                    dataIsrl={dataIsrl}
                    montocausar={
                      txtMontoOrden.current
                        ? parseFloat(
                            txtMontoOrden.current.value
                              .replace(/\./g, "")
                              .replace(",", ".")
                          )
                        : 0.0
                    }
                    nombreprov={
                      txtNombreprov.current ? txtNombreprov.current.value : ""
                    }
                    onHideEliminarRetIsrl={eliminarRetencionesIslr}
                    desde={desde}
                  />
                </fieldset>

                <fieldset className="row border-azul rounded mx-auto container mb-2">
                  <legend className="float-none m-0 w-auto fw-bold" >
                    Datos de las Retenciones
                  </legend>

                  <TablaRetenOrdenPago
                    data={BaseDatosRet}
                    datarecords={datosRet}
                    operacion={operacion}
                    tipocomp={tipoComp}
                    itemselect={itemSelect}
                    facturasel={dataFac[itemSelect]}
                    natural={natural}
                    montoislr={reteIslr}
                    desde={desde}
                  />
                </fieldset>
              </div>
              <div
                className={tabs.tab4}
                id="div4"
                role="tabpanel"
                aria-labelledby="tab4"
              >
                <div className="col-md-12 px-0">
                  <TablaRetenISLR
                    data={BaseDatosIsrl}
                    datarecords={datosIsrl}
                    operacion={operacion}
                    natural={natural}
                    montoislr={reteIslr}
                    retenido={totalRetenido}
                    totalbaseimpo={totalBaseImpo}
                    totalfactura={totalFactura}
                    desde={desde}
                  />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton onClick={onChangeValidar} disabled={props.operacion === 4 ? true : false} ref={btnAcepta}>
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar} >
           Cancelar
        </DangerButton>
        {(props.ordenp && props.operacion !== 1) &&
          <InfoButton icon = 'fa-print m-0' onClick={imprimirOrdenPago}>
            Imprimir
          </InfoButton>
        }
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={handleCloseNo}
        onHideSi={handleCloseSi}
      />
      <ValidarUsuario
        show={mostrarUsuario}
        onHideCancela={() => {
          setMostrarUsuario(false);
          setDesde(0);
        }}
        onHideConfirmar={aceptaClaveSupervisor}
        llamado={0}
      />
      <CambiodeDatos
        show={cambiarDatos}
        onHideCancela={() => {
          setCambiarDatos(false);
        }}
        onHideConfirmar={aceptaCambioDatos}
        llamado={llamado}
        codigo={txtCodigo.current ? txtCodigo.current.value : ""}
        fecha={fecha}
        fechad={txtFechaOP.current ? txtFechaOP.current.value : ""}
        validarfechad={true}
      />
      <CatalogoFondoAvanceAprob
        show={mostrar7}
        condicion={condicion}
        onHideCancelar={handleCancelaFondos}
        onHideAceptaFondos={handleAceptarFondos}
      />
      <CatalogoAprobacionesFondoTerc1
        show={mostrar1}
        onHideCancelar={handleCancelaFondosT}
        onHideAceptaFondos={handleAceptarFondosT}
      />
      <CatalogoSPagoObra1
        show={mostrar2}
        tiposoli={0}
        onHideCancelar={handleCancelaSPagoObra1}
        onHideAceptar={handleAceptarSPagoObra1}
      />
      <CatalogoConceptoAumentoFondoAvance
        show={mostrar10}
        idfondo={idFondo}
        onHideCancelar={handleCancelaConceptoFondo}
        onHideAceptaFondos={handleAceptaConceptoFondo}
      />
      <CatalogoProveedor
        show={catalogoProve}
        onHideCancelaCatProv={() => {
          setCatalogoProve(false);
        }}
        onHideAceptaCatProv={validarProveedor}
        tipo={2}
      />
      <CatalogoPagadoReposi
        show={mostrar4}
        idefiscal={
          cmbAnio.current && idEfis && idEfis.length > 0
            ? idEfis[cmbAnio.current.selectedIndex]?.idefiscal ?? 0
            : 0
        }
        onHideCancelar={handleCancelaPagadoReposi}
        onHideAceptar={handleAceptaPagadoReposi}
      />
      <CatalogoOrdenPagoxPagar
        show={mostrar8}
        onHideCancelar={handleCancelaOrdenPagoxPagar}
        onHideAceptar={handleAceptaOrdenPagoxPagar}
      />
      <ModalModificarFact
        show={mostrar6}
        onHideCancela={() => {
          setMostrar6(false);
          seleccionarRetencionesOrdenPago(props.ordenp.idordenpago, idefiscal);
          SeleccionarRetencionesIsrlOrdenPago(
            props.ordenp.idordenpago,
            idefiscal
          );
        }}
        data={datosFac}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
